<!-- This component needs to be manually positioned when imported,
  to the top left corner below the top bar (also handle mobile position).
  The component aims to cover all of the screen except from the top bar. -->
<template>
  <div
    class="overlay-card__background"
    :class="{ 'overlay-card__background__transparent': backgroundTransparent }"
    @click.self="emits('closeOverlay')"
  >
    <div class="overlay-card__content">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
// The backgroundTransparent prop can be used if the OverlayCard is shown while an overlay modal is active
defineProps({
  backgroundTransparent: {
    type: Boolean,
    default: false
  }
})
type EMITS = (e: 'closeOverlay') => void
const emits = defineEmits<EMITS>()
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
.overlay-card {
  &__background {
    align-items: center;
    background-color: rgba(26, 26, 26, 0.4);
    display: flex;
    flex-direction: column;
    height: calc(100vh - #{variables.$layout-top-bar-height});
    justify-content: center;
    position: absolute;
    width: 100vw;
    z-index: 136;
    &__transparent {
      background-color: transparent;
    }
  }
  &__content {
    background-color: variables.$color-pure-white;
    border: 1px solid variables.$color-greyscale-line-grey;
    border-radius: 12px;
    box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.12);
    display: flex;
    margin-bottom: 32px;
    padding: 24px;
    min-height: fit-content;
    min-width: 200px;
  }
}
</style>
